'use strict'

export default (mockAxios) => {
  mockAxios.onGet(`/users`).reply(200, {
    'success': true,
    'data': [
      {
        'sid_corporate': 1,
        'id': 10,
        'loginid': 'yamada',
        'pwdmoddate': '2018/01/01',
        'level': 0,
        'bcard_exportable': '1',
        'user_state': '0',
        'seqno': 18,
        'last_name': '山田',
        'first_name': '一郎',
        'last_kana': 'やまだ',
        'first_kana': 'いちろう',
        'corporate_name': '海山商事',
        'corporate_kana': 'うみやましょうじ',
        'dept': 'ソリューション事業部',
        'post': '課長',
        'mail': 'suzuki@example.jp',
        'zipcode': '220-0001',
        'address1': '神奈川県横浜市西区みなとみらい',
        'address2': 'ランドマークタワー',
        'corporate_tel': '045-123-4567',
        'dept_tel': '045-123-5678',
        'naisen': 1234,
        'hand_tel': '090-1234-4567',
        'fax': '045-123-5678',
        'url': 'http://www.example.jp',
        'finallogin': '2018/01/01',
        'lastlogin': '2018/01/01',
        'defgroup': 102,
        'image_id': '01k200h0173wreha',
        'login_failures': 5,
        'login_fail_time': ' ',
        'group_users': [
          {
            'sid_corporate': 1,
            'id': 10,
            'sid_assign': 21,
            'seqno': 18,
            'group': {
              'id': 10,
              'name': '組織１',
              'tel': ' ',
              'memo': ' ',
              'const_id': ' ',
              'orgconst_id': ' '
            }
          }
        ],
        'full_name': '山田 一郎',
        'full_kana': 'やまだ いちろう'
      }
    ],
    'pagination': {
      'page_count': 2,
      'current_page': 1,
      'has_next_page': true,
      'has_prev_page': false,
      'count': 123,
      'limit': 100
    }
  })

  mockAxios.onPost(`/users`).reply(201, {
    'success': true,
    'data': {
      'id': 10
    }
  })

  mockAxios.onGet(new RegExp(`/users/\\d+`)).reply(200, {
    'success': true,
    'data': {
      'sid_corporate': 1,
      'id': 10,
      'loginid': 'yamada',
      'pwdmoddate': '2018/01/01',
      'level': 0,
      'bcard_exportable': '1',
      'user_state': '3',
      'seqno': 1,
      'last_name': '山田',
      'first_name': '一郎',
      'last_kana': 'やまだ',
      'first_kana': 'いちろう',
      'corporate_name': '海山商事',
      'corporate_kana': 'うみやましょうじ',
      'dept': 'ソリューション事業部',
      'post': '課長',
      'zipcode': '220-0001',
      'address1': '神奈川県横浜市西区みなとみらい',
      'address2': 'ランドマークタワー',
      'corporate_tel': '045-123-4567',
      'naisen': 1234,
      'dept_tel': '045-123-5678',
      'hand_tel': '090-1234-4567',
      'fax': '045-123-5678',
      'mail': 'suzuki@example.jp',
      'url': 'http://www.example.jp',
      'finallogin': '2018/01/01',
      'lastlogin': '2018/01/01',
      'defgroup': 102,
      'image_id': '01k200h0173wreha',
      'login_failures': 5,
      'login_fail_time': ' ',
      'group_users': [
        {
          'sid_corporate': 1,
          'id': 10,
          'sid_assign': 21,
          'seqno': 18,
          'group': {
            'id': 10,
            'name': '組織１'
          }
        }
      ],
      'images': [
        {
          'sid_attach': '01k20094169p8y3t',
          'id': 10,
          'name': 'sample_image.jpg',
          'image_url': '//localhost:8765/files/bimage/01k20094169p8y3t'
        }
      ],
      'word_': '***************',
      'full_name': '山田 一郎',
      'login_refused': false
    }
  })

  mockAxios.onPost(new RegExp(`/users/\\d+`)).reply(201, {
    'success': true,
    'data': []
  })

  mockAxios.onDelete(new RegExp(`/users/\\d+`)).reply(200, {
    'success': true,
    'data': []
  })

  mockAxios.onPut(new RegExp(`/users/logical-delete/\\d+`)).reply(200, {
    'success': true,
    'data': []
  })

  mockAxios.onPost(`/users/delete`).reply(200, {
    'success': true,
    'data': []
  })

  mockAxios.onPost(`/users/state`).reply(200, {
    'success': true,
    'data': []
  })

  mockAxios.onPost(`/users/login-reset`).reply(200, {
    'success': true,
    'data': []
  })

  mockAxios.onPut(`/users/sort`).reply(200, {
    'success': true,
    'data': []
  })

  mockAxios.onGet(new RegExp(`/users/\\d+/images`)).reply(200, {
    'success': true,
    'data': [
      {
        'sid_attach': '01k20094169p8y3t',
        'name': '裏面.jpeg',
        'seqno': 1,
        'isMain': '1',
        'image_url': '//example.com/file/uimage/01k200bl0svfx9m7'
      }
    ],
    'pagination': {
      'page_count': 2,
      'current_page': 1,
      'has_next_page': true,
      'has_prev_page': false,
      'count': 123,
      'limit': 100
    }
  })

  mockAxios.onGet(new RegExp(`/users/profile/\\d+`)).reply(200, {
    'id': 1,
    'image_id': '01k20094169p8y3t',
    'image_url': 'http://example/1',
    'level': '0',
    'full_name': '山田 太郎',
    'full_kana': 'やまだ たろう',
    'corporate_name': 'サンプル会社',
    'corporate_kana': 'さんぷるかいしゃ',
    'dept': 'サンプル部署1',
    'post': 'サンプル役職',
    'mail': 'yamada@example.com',
    'zipcode': '123-4567',
    'address1': '東京都町田市1-2-3',
    'address2': '太田ビル2F',
    'corporate_tel': '0330-88-1590',
    'dept_tel': '0330-88-1595',
    'naisen': '1234',
    'hand_tel': '080-1234-5678',
    'fax': '0330-88-1599',
    'url': 'http://www.rrr-computer.jp',
    'valid_url': 'http://www.rrr-computer.jp',
    'user_state': '0'
  })

  mockAxios.onPost(`/users/export`).reply(200, {
    'success': true
  })

  mockAxios.onGet(`/users/export`).reply(200, {
  })

  mockAxios.onGet(`/users/export-result`).reply(200, {
    'success': true,
    'result': 'success',
    'status': 'finish'
  })

  mockAxios.onPost(`/users/export-cancel`).reply(200, {
    'success': true
  })

  mockAxios.onPost(`/users/import`).reply(200, {
    'success': true
  })

  mockAxios.onGet(`/users/import-result`).reply(200, {
    'success': true,
    'result': 'success',
    'message': '2件のレコードがインポートされました。'
  })

  // 名刺検索
  mockAxios.onPost(`/users/search`).reply((config) => {
    let response = [
      200,
      {
        'success': true,
        'data': [
          {
            'id': 1,
            'dept': 'ソリューション事業部',
            'post': '課長',
            'full_name': '山田 一郎'
          },
          {
            'id': 2,
            'dept': '経理部',
            'post': '',
            'full_name': '佐藤 みのり'
          }
        ],
        'pagination': {
          'page_count': 5,
          'current_page': 1,
          'has_next_page': true,
          'has_prev_page': false,
          'count': 55,
          'limit': 10
        }
      }
    ]

    const params = config.params || {}

    if (params.get_dels === '1') {
      response[1].data.push({
        'id': 3,
        'dept': '経理部',
        'post': '',
        'full_name': '使用 停止太郎'
      })
      response[1].data.push({
        'id': 4,
        'dept': '',
        'post': '',
        'full_name': '論理 削除子'
      })
    }

    return response
  })
}



// WEBPACK FOOTER //
// ./src/repositories/mock/userRepositoryMock.js